import stampit from 'stampit'
import Firestore from './firestore'

const Face = stampit(Firestore, {
  name: 'Face',
  props: {
    apng: '',
    thumb: '',
    talkr: '',
    gender: 'female',
    speed: 1.0
  },
  statics: {
    defaultThumb: '/static/lilythumb.jpg',
    defaultAPNG: '/static/lilyAPNG.png'
  },
  init ({apng, thumb, talkr, speed, gender}) {
    this.apng = apng || Face.defaultAPNG
    this.thumb = thumb || Face.defaultThumb
    this.talkr = talkr || ''
    this.speed = speed || 1.0
    this.gender = gender || 'female'
  }
})
export default Face



// WEBPACK FOOTER //
// ./src/tts/face.js